<section>
  <header>
    <div class="logo-container">
      <figure>
        <img
          *ngIf="userBrandingSettings"
          src="{{ userBrandingSettings.sideImageUrl }}"
        />
        <figcaption *ngIf="!isUserHasCurrentChannel && userBrandingSettings">
          {{ userBrandingSettings.headerText }}
        </figcaption>
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="20px"
          height="20px"
          viewBox="0 0 20 20"
          style="enable-background: new 0 0 20 20"
          xml:space="preserve"
          *ngIf="isUserHasCurrentChannel && notInChannelDashboard"
          (click)="openChannelPreview.emit(channel)"
        >
          <style type="text/css">
            .st0 {
              fill: #879baf;
            }

            .st1 {
              fill-rule: evenodd;
              clip-rule: evenodd;
              fill: #757575;
            }
          </style>
          <g>
            <path
              class="st0"
              d="M10,1c5,0,9,4,9,9s-4,9-9,9s-9-4-9-9S5,1,10,1 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0
                            L10,0z"
            />
            <polygon class="st0" points="8,13.7 14,10 8,6.3" />
          </g>
        </svg>
      </figure>
    </div>
    <div class="channelName" *ngIf="isUserHasCurrentChannel">
      {{ channel.name | uppercase }}
    </div>
    <div class="divider" *ngIf="isUserHasCurrentChannel"></div>
    <nav>
      <ichannel-link [name]="'Channels'" [link]="'channels'"></ichannel-link>
    </nav>
    <div class="divider" *ngIf="notInChannelDashboard"></div>
    <nav>
      <!-- Should be Component -->
      <ichannel-link
        *ngIf="
          currentUser &&
          channel &&
          currentUser.hasViewSchedulerPermission(channel)
        "
        [name]="'Scheduler'"
        [link]="'scheduler/calendar'"
      ></ichannel-link>
      <!-- <ichannel-link
        [name]="'Sources'"
        [link]="'live-sources'"
        *ngIf="currentUser && currentUser.isSuperUser"
      ></ichannel-link> -->

      <ichannel-link
        *ngIf="currentUser && currentUser.hasEditMAMPermission"
        [name]="'MAM'"
        [link]="'mam/uploadReport'"
      ></ichannel-link>

      <ichannel-link
        *ngIf="
          currentUser &&
          channel &&
          currentUser.hasEditSchedulePermission(channel)
        "
        [name]="'Autopilot'"
        [link]="'autopilot'"
      ></ichannel-link>
      <ichannel-link
        *ngIf="currentUser && channel && currentUser.isLiveManager"
        [name]="'Live'"
        [link]="'live'"
      ></ichannel-link>
      <ichannel-link
        [name]="'Media Transcoder'"
        [link]="'media-transcoder'"
        *ngIf="currentUser && currentUser.hasEditMediaTranscodingPermission"
      ></ichannel-link>
      <ichannel-link
        [name]="'Recording'"
        [link]="'recording/schedule'"
        *ngIf="currentUser && channel && currentUser.hasRecordingPermission"
      ></ichannel-link>
      <ichannel-link
        [name]="'Monitoring'"
        [link]="'monitoring-platforms'"
        *ngIf="currentUser && currentUser.isSuperUser"
      ></ichannel-link>
      <!-- <ichannel-link
        [name]="'Outpost'"
        [link]="'outpost'"
        *ngIf="currentUser && currentUser.isSuperUser"
      ></ichannel-link> -->
     <div
        class="nav-dropdown"
        *ngIf="currentUser && currentUser.isContentControlManager"
      >
        <ichannel-link
          [name]="'Content Control'"
          [link]="'content-control'"
          [is-sub-menu-link]="true"
        ></ichannel-link>
        <div class="nav-submenu">
          <ichannel-link
            [name]="'VOD'"
            [link]="'content-control/hub'"
          ></ichannel-link>
          <ichannel-link
            [name]="'LIVE'"
            [link]="'content-control/operation-room'"
          ></ichannel-link>
        </div>
      </div>

      <div
        class="nav-dropdown"
        *ngIf="
          currentUser &&
          (currentUser.hasEditMAMPermission || currentUser.isSuperUser)
        "
      >
        <ichannel-link
          [name]="'Clipping Studio'"
          [link]="'clipping-studio'"
          [is-sub-menu-link]="true"
        ></ichannel-link>
        <div class="nav-submenu">
          <ichannel-link
            *ngIf="currentUser && currentUser.hasEditMAMPermission"
            [name]="'Clipping Hub'"
            [link]="'clipping-studio/mam-explorer'"
          ></ichannel-link>
          <ichannel-link
            *ngIf="currentUser && currentUser.isSuperUser"
            [name]="'Publications'"
            [link]="'clipping-studio'"
          ></ichannel-link>
        </div>
      </div>
    </nav>
    <ul class="tools">
      <li [hidden]="!showLiveButton">
        <live-indicator [isLive]="isLive"></live-indicator>
      </li>
      <!-- <li [hidden]="!showLiveButton">
        <go-live-button></go-live-button>
      </li> -->

      <li
        class="live-broadcast-button"
        *ngIf="
          currentUser &&
          channel &&
          !channel.isBlock &&
          currentUser.hasEditSchedulePermission(channel)
        "
      >
        <evrideo-live-broadcast-link></evrideo-live-broadcast-link>
      </li>
      <li>
        <circle-indicator
          [status]="systemWorkingIndicatorStatus"
        ></circle-indicator>
      </li>
      <li class="trialLeftMessage" *ngIf="isTrialUser && trialDaysLeft">
        Your Free Trial Ends in
        <span class="bold">{{ trialDaysLeft }}</span> Day(s)
      </li>
      <li
        class="dropdown-menu"
        *ngIf="
          currentUser &&
          channel &&
          currentUser.hasEditSchedulePermission(channel)
        "
      >
        <!-- Menu -->
        <icn-navbar-menu
          [active]="showUserAlertsMenu"
          [animateOut]="animateOut"
        >
          <!-- Menu Header -->
          <div icn-navbar-menu-header>
            <a
              href="#!"
              (click)="toggleUserAlertsMenu($event)"
              [ngClass]="{ open: showUserAlertsMenu }"
            >
              <span>
                <alerts-notification-button
                  [numberOfErrors]="reportAlertsCounter"
                ></alerts-notification-button>
              </span>
            </a>
          </div>

          <!-- Menu Body -->
          <div icn-navbar-menu-items>
            <!-- Profile Section -->
            <div>
              <alerts></alerts>
            </div>
          </div>
        </icn-navbar-menu>
      </li>
      <li class="dropdown-menu">
        <!-- Menu -->
        <icn-navbar-menu [active]="showProfileMenu" [animateOut]="animateOut">
          <!-- Menu Header -->
          <div icn-navbar-menu-header>
            <a
              href="#!"
              (click)="profileMenuToggle($event)"
              class="profile-menu-toggle"
              [ngClass]="{ open: showProfileMenu }"
            >
              <span>{{ getFullName() }}</span>
              <i class="fa fa-angle-down"></i>
            </a>
          </div>

          <!-- Menu Body -->
          <div icn-navbar-menu-items>
            <!-- Profile Section -->
            <div class="profile-container">
              <i>
                <span>{{ getFirstChartInUsername() }}</span>
              </i>
              <span>{{ getUserEmail() }}</span>
            </div>

            <!-- Menu Items -->
            <a [routerLink]="'mam/uploadReport'">
              <icn-navbar-menu-item
                label="Media Uploads Report"
              ></icn-navbar-menu-item>
            </a>
            <a [routerLink]="'reports/schedule-alerts'">
              <icn-navbar-menu-item
                label="Schedule alerts report"
              ></icn-navbar-menu-item>
            </a>
            <icn-navbar-menu-item
              *ngIf="isUserHasCurrentChannel || currentUser"
              label="Import"
            >
              <div
                *ngIf="
                  currentUser &&
                  channel &&
                  currentUser.hasEditSchedulePermission(channel) &&
                  getUserDynamicScripts().length > 0
                "
              >
                <icn-navbar-menu-item
                  *ngFor="let script of getUserDynamicScripts()"
                  [label]="script.displayName"
                  (click)="onDynamicScriptClick(script)"
                ></icn-navbar-menu-item>
              </div>
              <icn-navbar-menu-item
                *ngIf="currentUser && currentUser.hasBatchUploadPermission"
                [routerLink]="'batchimport'"
                label="Batch Import"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                *ngIf="currentUser && currentUser.isSuperUser"
                [routerLink]="'uploadgraphics'"
                label="Upload Graphics"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                *ngIf="currentUser && currentUser.hasEditMAMPermission"
                [routerLink]="'scheduler/import-segments'"
                label="Upload Segments CSV"
              ></icn-navbar-menu-item>
            </icn-navbar-menu-item>
            <icn-navbar-menu-item label="Export">
              <icn-navbar-menu-item
                (click)="getFullMediaReport()"
                label="Full Media CSV Report"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                *ngIf="currentUser && currentUser.isSuperUser"
                (click)="getMediaMetadataReport()"
                label="Media Metadata CSV Report"
              ></icn-navbar-menu-item>

              <icn-navbar-menu-item
                (click)="showFullSegmentsReportPopup()"
                label="Full Segments CSV Report"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                (click)="showCensorshipAiReportPopup()"
                label="Censorship AI Report"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                *ngIf="
                  currentUser &&
                  channel &&
                  currentUser.hasViewSchedulerPermission(channel) &&
                  notInChannelDashboard
                "
                [routerLink]="'exportepg'"
                label="Export EPG"
              ></icn-navbar-menu-item>
              <icn-navbar-menu-item
                *ngIf="
                  currentUser &&
                  channel &&
                  currentUser.hasViewSchedulerPermission(channel) &&
                  notInChannelDashboard
                "
                [routerLink]="'exportrunlog'"
                label="Export as Run Log"
              ></icn-navbar-menu-item>
            </icn-navbar-menu-item>
            <icn-navbar-menu-item
              *ngIf="
                currentUser &&
                (currentUser.hasManageUsersPermission ||
                  currentUser.isContentControlManager)
              "
              label="Users"
            >
              <icn-navbar-menu-item
                *ngIf="currentUser && currentUser.hasManageUsersPermission"
                label="Manage Users"
                [routerLink]="'users/list'"
              ></icn-navbar-menu-item>
              <!--<a [routerLink]="'tenant/request-demo'">
                <icn-navbar-menu-item
                  *ngIf="currentUser.isSuperUser"
                  label="Add a Trial User"
                ></icn-navbar-menu-item>
              </a>-->
              <icn-navbar-menu-item
                [routerLink]="'tenantsettings'"
                *ngIf="
                  currentUser.isSuperUser || currentUser.isContentControlManager
                "
                label="Tenant Settings"
              ></icn-navbar-menu-item>
              <a [routerLink]="'user-branding'" *ngIf="currentUser.isSuperUser">
                <icn-navbar-menu-item
                  label="White Label Settings"
                ></icn-navbar-menu-item>
              </a>
            </icn-navbar-menu-item>
            <icn-navbar-menu-item
              *ngIf="
                notInChannelDashboard &&
                currentUser &&
                channel &&
                currentUser.hasEditSchedulePermission(channel)
              "
              label="Additional Actions"
            >
              <icn-navbar-menu-item
                label="Clean Scheduler"
                [routerLink]="'cleanscheduler'"
              ></icn-navbar-menu-item>
              <a>
                <icn-navbar-menu-item
                  label="Update Playout"
                  (click)="updatePlayout()"
                ></icn-navbar-menu-item>
              </a>
            </icn-navbar-menu-item>
            <icn-navbar-menu-item
              *ngIf="
                notInChannelDashboard &&
                channel &&
                currentUser &&
                currentUser.hasEditChannelSettingsPermission(channel) &&
                currentUser.hasEditSchedulePermission(channel)
              "
              label="Channel Settings"
              [routerLink]="['/channels/edit/' + channel.id]"
            ></icn-navbar-menu-item>
            <icn-navbar-menu-item
              label="Switch Tenant"
              *ngIf="
                currentUser &&
                (currentUser.isSuperUser ||
                  currentUser.managedTenants.length > 0)
              "
              (click)="switchTenantClickedEventHandler()"
            ></icn-navbar-menu-item>
            <icn-navbar-menu-item
              label="Logout"
              (click)="logout()"
            ></icn-navbar-menu-item>
          </div>
        </icn-navbar-menu>
      </li>
    </ul>
  </header>
  <clock
    *ngIf="currentUser"
    [currentChannel]="channel"
    [userTimeZones]="currentUser && currentUser.timezones"
  ></clock>
</section>

<ngx-smart-modal
  #switchTenantPopup
  identifier="switchTenantPopupModal"
  [@.disabled]="true"
  *ngIf="currentUser && currentUser.managedTenants.length > 0"
>
  <div class="manage-users-popup">
    <h1>Choose Tenant</h1>
    <div class="filter" *ngIf="currentUser.managedTenants.length > 10">
      <label>Filter: </label>
      <input
        type="text"
        [(ngModel)]="managedTenantFilter"
        (ngModelChange)="managedTenantFilterChangedEventHandler($event)"
        #managedTenantFilterElement
      />
    </div>
    <ul>
      <li
        *ngFor="let tenant of userMangedTenants"
        (click)="switchToTenant(tenant)"
      >
        {{ tenant.name }}
      </li>
    </ul>
  </div>
</ngx-smart-modal>

<ngx-smart-modal
  #exportFullSegmentsReport
  identifier="exportFullSegmentsReportPopupModal"
  [@.disabled]="true"
  *ngIf="currentUser && currentUser.managedTenants.length > 0"
>
  <div>
    <h1>Export Full Segments Report</h1>
    <div class="fields">
      Choose format:
      <input
        type="radio"
        id="fullSegmentReportFormatFPS"
        name="fullSegmentReportFormat"
        [checked]="selectedFullSegmentReportFormat === 'FPS'"
        (change)="changeReportFormat('FPS')"
      /><label for="fullSegmentReportFormatFPS">FPS</label>
      <input
        type="radio"
        id="fullSegmentReportFormatMS"
        name="fullSegmentReportFormat"
        [checked]="selectedFullSegmentReportFormat === 'MS'"
        (change)="changeReportFormat('MS')"
      /><label for="fullSegmentReportFormatMS">MS</label>
    </div>
    <div class="buttons">
      <ichannel-button
        [label]="'Export'"
        [theme]="'DARK'"
        (click)="downloadFullSegmentReport()"
      ></ichannel-button>
    </div>
  </div>
</ngx-smart-modal>
<ngx-smart-modal
  #exportCensorshipAiReport
  identifier="exportCensorshipAiReportPopupModal"
  [@.disabled]="true"
  *ngIf="currentUser"
>
  <div class="censorship-ai-report">
    <h1>Censorship AI Report</h1>
    <div class="fields">
      <div class="media-id-pattern field">
        <label>VIDEO ID PATTERN:</label>
        <ichannel-input
          class="name-input"
          [(value)]="censorshipAiReportVideoIdPatternField"
        ></ichannel-input>
      </div>
      <div class="date-picker field">
        <label>SELECT DATE RANGE:</label>
        <div>
          <label>From:</label>
          <dateinput [(current)]="censorshipAiReportFromTimeField"></dateinput>
          <label>To:</label>
          <dateinput [(current)]="censorshipAiReportToTimeField"></dateinput>
        </div>
      </div>

      <div class="report-type field">
        <label>CHOOSE FORMAT:</label>
        <ul style="list-style-type: none">
          <li>
            <input
              type="radio"
              id="censorshipAiReportTypeOnlySummary"
              name="censorshipAiReportType"
              [checked]="selectedCensorshipAiReportType === 'OnlySummary'"
              (change)="changeCensorshipAiReportType('OnlySummary')"
            /><label for="censorshipAiReportTypeOnlySummary"
              >Only Summary</label
            >
          </li>
          <li>
            <input
              type="radio"
              id="censorshipAiReportTypeSummaryPerItem"
              name="censorshipAiReportType"
              [checked]="selectedCensorshipAiReportType === 'SummaryPerItem'"
              (change)="changeCensorshipAiReportType('SummaryPerItem')"
            /><label for="censorshipAiReportTypeSummaryPerItem"
              >Summary Per Item</label
            >
          </li>
          <li>
            <input
              type="radio"
              id="censorshipAiReportTypeSummaryDetailed"
              name="censorshipAiReportType"
              [checked]="selectedCensorshipAiReportType === 'Detailed'"
              (change)="changeCensorshipAiReportType('Detailed')"
            /><label for="censorshipAiReportTypeSummaryDetailed"
              >Detailed</label
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="ai-report-buttons">
      <ichannel-button
        [label]="processingCensorshipAiReport ? 'Processing...' : 'Generate'"
        [theme]="processingCensorshipAiReport ? 'DISABLED' : 'DARK'"
        (click)="!processingCensorshipAiReport && downloadCensorshipAiReport()"
      ></ichannel-button>
    </div>
  </div>
</ngx-smart-modal>
